import { render, staticRenderFns } from "./RichTextPreview.vue?vue&type=template&id=6f32deff&scoped=true&"
import script from "./RichTextPreview.vue?vue&type=script&lang=js&"
export * from "./RichTextPreview.vue?vue&type=script&lang=js&"
import style0 from "./RichTextPreview.vue?vue&type=style&index=0&id=6f32deff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f32deff",
  null
  
)

export default component.exports